// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function FooterMenuItem(Props) {
  let menu = Props.menu;
  let idx = Props.idx;
  const country = Buhta_landing__Route.getCountry(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const languageStr = Buhta_models__Locale.toString(Buhta_landing__Route.getLanguage(undefined));
  const Key = "dropdown_" + String(idx);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("p", {
        children: menu.name,
        className: "label-medium text-gray-landing"
      }),
      JsxRuntime.jsx("ul", {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, item) {
          const url = "/" + countryStr + "/" + languageStr + item.path;
          const Key = "dropdown_" + String(index);
          return JsxRuntime.jsxs("li", {
            children: [
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: Buhta_landing__Route.ofUrl(Buhta_landing__Route.getRouterUrl(url)),
                className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing mr-2",
                children: item.title
              }),
              item.path === "/" ? JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/soon.svg")
                }) : null
            ],
            className: "mt-2 flex flex-wrap"
          }, Key);
        }), Stdlib__List.sort((function (a, b) {
          return a.order - b.order | 0;
        }), menu.menu_items))),
        className: "paragraph-small text-gray-landing mt-5"
      })
    ],
    className: "w-57"
  }, Key);
}

const make = FooterMenuItem;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
